module.exports = __webpack_public_path__ + "img/title-.bf2bd044.png";